import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

export default function ParentEmailEditor({ studentId }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(null);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    setAccounts([]);
    axios.get(`/students/${studentId}/parent-emails`).then(({ data }) => {
      if (active) setAccounts(data.map(p => ({ ...p, draft: p.email || '' })));
    }).catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [studentId]);
  const save = async (event, parent) => {
    event.preventDefault();
    setSaving(parent.id);
    try {
      const { data } = await axios.put(`/students/${studentId}/parent-emails/${parent.id}`, { email: parent.draft });
      setAccounts(prev => prev.map(p => p.id === parent.id ? { ...p, email: data.email, draft: data.email } : p));
      toast.success('Correo del padre actualizado');
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Revisa el correo e intenta nuevamente');
    } finally { setSaving(null); }
  };
  return <div className="rounded-lg border p-4 space-y-3">
    <h3 className="font-semibold">Correos de las cuentas de padres</h3>
    <p className="text-sm text-slate-500">El correo se actualiza para esta cuenta y todos sus hijos vinculados. El usuario y la contraseña se conservan.</p>
    {loading ? <p>Cargando cuentas...</p> : error ? <p role="alert">No se pudieron cargar las cuentas de padres. Vuelve a abrir el expediente.</p> : accounts.length === 0 ? <p className="text-sm text-slate-500">Este estudiante no tiene cuentas de padres vinculadas.</p> : accounts.map(parent =>
      <form key={parent.id} onSubmit={e => save(e, parent)} className="space-y-1">
        <Label htmlFor={`parent-email-${parent.id}`}>{parent.label}: {parent.full_name || parent.username}</Label>
        <div className="flex flex-col sm:flex-row gap-2">
          <Input id={`parent-email-${parent.id}`} type="email" required value={parent.draft}
            disabled={saving !== null} autoComplete="off"
            onChange={e => setAccounts(prev => prev.map(p => p.id === parent.id ? { ...p, draft: e.target.value } : p))} />
          <Button type="submit" disabled={saving !== null || parent.draft.trim().toLowerCase() === (parent.email || '').toLowerCase()}>
            {saving === parent.id ? 'Guardando...' : 'Guardar correo'}
          </Button>
        </div>
      </form>)}
  </div>;
}
